import type { Company } from "@/types";
import { computed, type ComputedRef } from "vue";

/**
 * Shared composable for allocation cards to handle company mode detection
 *
 * Provides computed properties for:
 * - Single vs multi-company mode detection
 * - Current company reference (null in multi-company mode)
 * - Edit capability based on company mode
 */
export function useCompanyMode(companies: ComputedRef<Company[]>) {
  const isSingleCompany = computed(() => companies.value.length === 1);

  const currentCompany = computed(() =>
    isSingleCompany.value ? companies.value[0] : null
  );

  const canEdit = computed(() => isSingleCompany.value);

  return {
    isSingleCompany,
    currentCompany,
    canEdit,
  };
}
